import React from 'react';
import { AiOutlineLaptop } from 'react-icons/ai';
import { MdFastfood } from 'react-icons/md';
import { MdRealEstateAgent } from 'react-icons/md';
import { BsCartPlus } from 'react-icons/bs';
import { BiBookOpen } from 'react-icons/bi';
import { MdPets } from 'react-icons/md';

const OtherServices = () => {
    return (
        <>
            <section className="section">

                <div className="container">
                    <div className="row">
                        <div className="col-12">

                            <div className="section-title">
                                <h2>Our Other Business</h2>

                            </div>
                            <div className="row">

                                <div className="col-lg-3 offset-lg-0 col-md-5 offset-md-1 col-sm-6 col-6">
                                    <div className="category-block">
                                        <div className="header">
                                            <AiOutlineLaptop className='icon-bg-1'> </AiOutlineLaptop>

                                            <h4>Electronics</h4>
                                        </div>
                                        <ul className="category-list">
                                            <li>
                                                <a href="/">Laptops <span>93</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Iphone <span>233</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Microsoft <span>183</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Monitors <span>343</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 offset-lg-0 col-md-5 offset-md-1 col-sm-6 col-6">
                                    <div className="category-block">
                                        <div className="header">
                                            <MdFastfood className='icon-bg-1'> </MdFastfood>

                                            <h4>Restaurants</h4>
                                        </div>
                                        <ul className="category-list">
                                            <li>
                                                <a href="/">Cafe <span>393</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Fast food <span>23</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Restaurants <span>13</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Food Track<span>43</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 offset-lg-0 col-md-5 offset-md-1 col-sm-6 col-6">
                                    <div className="category-block">
                                        <div className="header">
                                            <MdRealEstateAgent className='icon-bg-1'> </MdRealEstateAgent>
                                            <h4>Real Estate</h4>
                                        </div>
                                        <ul className="category-list">
                                            <li>
                                                <a href="/">Farms <span>93</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Gym <span>23</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Hospitals <span>83</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Parolurs <span>33</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 offset-lg-0 col-md-5 offset-md-1 col-sm-6 col-6">
                                    <div className="category-block">
                                        <div className="header">
                                            <BsCartPlus className='icon-bg-1'> </BsCartPlus>
                                            <h4>Shoppings</h4>
                                        </div>
                                        <ul className="category-list">
                                            <li>
                                                <a href="/">Mens Wears <span>53</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Accessories <span>212</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Kids Wears <span>133</span></a>
                                            </li>
                                            <li>
                                                <a href="/">It & Software <span>143</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 offset-lg-0 col-md-5 offset-md-1 col-sm-6 col-6">
                                    <div className="category-block">
                                        <div className="header">
                                            <BiBookOpen className='icon-bg-1'> </BiBookOpen>
                                            <h4>Jobs</h4>
                                        </div>
                                        <ul className="category-list">
                                            <li>
                                                <a href="/">It Jobs <span>93</span></a>
                                            </li>
                                            <li>
                                                <a href="/"
                                                >Cleaning & Washing <span>233</span></a
                                                >
                                            </li>
                                            <li>
                                                <a href="/">Management <span>183</span></a>
                                            </li>
                                            <li>
                                                <a href="/"
                                                >Voluntary Works <span>343</span></a
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 offset-lg-0 col-md-5 offset-md-1 col-sm-6 col-6">
                                    <div className="category-block">
                                        <div className="header">
                                            <MdPets className='icon-bg-1'> </MdPets>

                                            <h4>Vehicles</h4>
                                        </div>
                                        <ul className="category-list">
                                            <li>
                                                <a href="/">Bus <span>193</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Cars <span>23</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Motobike <span>33</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Rent a car <span>73</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 offset-lg-0 col-md-5 offset-md-1 col-sm-6 col-6" >
                                    <div className="category-block">
                                        <div className="header">
                                            <MdPets className='icon-bg-1'> </MdPets>

                                            <h4>Pets</h4>
                                        </div>
                                        <ul className="category-list">
                                            <li>
                                                <a href="/">Cats <span>65</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Dogs <span>23</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Birds <span>113</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Others <span>43</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 offset-lg-0 col-md-5 offset-md-1 col-sm-6 col-6">
                                    <div className="category-block">
                                        <div className="header">
                                            <AiOutlineLaptop className='icon-bg-1'></AiOutlineLaptop>
                                            <h4>Services</h4>
                                        </div>
                                        <ul className="category-list">
                                            <li>
                                                <a href="/">Cleaning <span>93</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Car Washing <span>233</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Clothing <span>183</span></a>
                                            </li>
                                            <li>
                                                <a href="/">Business <span>343</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    );
};

export default OtherServices;